import React, { FC } from 'react';
import { SelectArrayInput, useTranslate } from 'react-admin';
import { H3 } from '~/components';
import { useAllRoles } from '~/hooks/roles';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { l } from '~/utils/solutions';

interface ReversalSupportFormProps {
  keyName: string;
}

export const ReversalSupportForm: FC<ReversalSupportFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  const { data: roles = [] } = useAllRoles();

  return (
    <>
      <H3 topSpacing={0} bottomSpacing={2}>
        {t('reversalSupportTitle')}
      </H3>
      <SelectArrayInput
        label={t('reversalSupportNotifyRoles')}
        source={`${keyName}.settings.notifyRoles`}
        choices={roles}
        className={classes.inputWidth}
      />
    </>
  );
};
